import actions from './actions'
import getters from './getters'
import mutations from './mutations'

const getDefaultState = () => {
  return {
    id: null,
    hasResult: false,
    hasCountryDeal: false,
    hasGlobalUnlimited: false,
    hasUnlimited: false,
    hasMembership: false,
    countryName: null,
    toCountry: null,
    hasAppToApp: false,
    unlimited: {},
    globalUnlimited: {},
    worldCredit: {},
    limited: {},
    recargas: {},
    membership: {}
  }
}

const state = getDefaultState()

mutations.RESET_STATE = (state) => {
  Object.assign(state, getDefaultState())
}
actions.reset = ({ commit }) => {
  commit('RESET_STATE')
}

export default {
  namespaced: true,
  state,
  actions,
  getters,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/rates/index.js